import { Control, Controller } from 'react-hook-form'
import PhoneInput from 'react-phone-number-input'

import 'react-phone-number-input/style.css'
import { ErrorText } from '../common/UI'

interface PhoneNumberControlProps {
    name: string
    control: Control<any>
    label: string
    rules?: object
    className?: string
}

export const PhoneNumberControl = ({
    name,
    control,
    label,
    rules,
    className
}: PhoneNumberControlProps): JSX.Element => {
    return (
        <div className={`w-full ${className}`}>
            <Controller
                name={name}
                control={control}
                rules={rules}
                render={({
                    field: { onChange, value },
                    fieldState: { error }
                }) => (
                    <div className="w-full flex flex-col gap-1">
                        <div
                            className={`
                                group relative w-full inline-flex flex-col items-start justify-center 
                                border-2 rounded-xl transition-all duration-200 px-3 h-14
                                bg-background
                                ${error
                                    ? 'border-danger/80'
                                    : 'border-default-200 hover:border-default-400 focus-within:border-primary'
                                }
                            `}
                        >
                            <label
                                className={`
                                    absolute z-10 top-1.5 left-3 text-[12px] font-medium transition-colors
                                    ${error ? 'text-danger' : 'text-default-600'}
                                `}
                            >
                                {label}
                            </label>

                            <div className="w-full mt-5 flex items-center">
                                <PhoneInput
                                    international
                                    defaultCountry="CO"
                                    value={value}
                                    onChange={onChange}
                                    className="w-full flex"
                                    numberInputProps={{
                                        className: 'w-full bg-transparent border-none outline-none text-base font-normal py-1 focus:ring-0 px-0'
                                    }}
                                    smartCaret={false}
                                />
                            </div>
                        </div>
                        {error && (
                            <div className="flex items-center gap-1 px-1 mt-0.5">
                                <span className="text-[11px] font-medium text-danger">
                                    {error.message}*
                                </span>
                            </div>
                        )}
                    </div>
                )}
            />
        </div>
    )
}
